

export const clientUA = (window?.navigator?.userAgent || '').toLocaleLowerCase();


export function isWechatMiniProgram(ua = clientUA) {
    return (!!clientUA.match(/miniprogram/i)) || window.isWeapp || false;
}


export function isSLApp() {
    if (!!clientUA.match(/shangrilaapp/i)) {
        return true;
    }
    
    if (typeof location !== "undefined") {
        return location.search.includes('source=APP');
    }

    return false;
}

export const isApp_5TH_BRAND = () => {
    if (typeof location !== "undefined") {
        return location.search.includes("source=5TH_BRAND");
    }
    return false;
};


export function isWebView() {
   try {
        return isWechatMiniProgram() || isSLApp() || isApp_5TH_BRAND()
   } catch (e) {
        return false
   }
   
}